import { FC, useEffect } from 'react';
import ShopifyCart from 'lowcode/common/ShopifyCart';
import styled from './index.module.scss';
import { useMembersStore } from './MembersProvider';
import Banner from './FY2024/Teaser/Banner';
import BuoySubscribe from './FY2024/Teaser/BuoySubscribe';
import TeaserCompoment from './FY2024/Teaser';
import ActivityCompoment from './FY2024/ActivityCom';
import ReturnCompoment from './FY2024/Return';
import EndCompoment from './FY2024/End';
import { IPageStatus } from './type';
import EfScrollAni from '@/efscrollani';

const MembersCompoment: FC = ({}) => {
    // const { useLang, useRouter, isApp } = useGlobal();
    const { isLogin, timeLine, pageStatus } = useMembersStore();

    useEffect(() => {
        console.log(pageStatus, isLogin, timeLine);
    }, []);

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                    .glo-editor-modal-show {
                        z-index: 2103;
                    }
                `}
            </style>
            <div className={`${styled.MembersCompoment}`}>
                <Banner />
                <BuoySubscribe />
                {pageStatus === IPageStatus.TEASER && <TeaserCompoment />}
                {pageStatus === IPageStatus.ACTIVITY && <ActivityCompoment />}
                {pageStatus === IPageStatus.RETURN && <ReturnCompoment />}
                {pageStatus === IPageStatus.END && <EndCompoment />}
            </div>
            <ShopifyCart />
        </>
    );
};

export default MembersCompoment;
